import React from "react";

import { useAgentNumber } from "../../context/AgentNumberContext";

const AGENT_NUMBER_LABEL = "Agent Number :";
/** Shown when the number could not be resolved — keeps the slot from collapsing. */
const UNRESOLVED_PLACEHOLDER = "—";

/**
 * Agent number shown next to the agent tabs.
 *
 * The slot is always reserved: a skeleton while the number resolves, an em dash
 * when it could not be resolved — so the tabs row never shifts once it lands.
 * Renders nothing when there is no agent in the URL to describe.
 */
const AgentNumberBadge: React.FC = () => {
  const agentNumberState = useAgentNumber();

  if (!agentNumberState?.agentId) return null;

  const { agentNumber, isLoading } = agentNumberState;

  return (
    <div className="badgeInfoCard">
      <span className="badgeInfo">
        {AGENT_NUMBER_LABEL}{" "}
        {isLoading ? (
          <span
            className="badgeInfo__skeleton"
            role="progressbar"
            aria-label="Loading agent number"
          />
        ) : (
          agentNumber || UNRESOLVED_PLACEHOLDER
        )}
      </span>
    </div>
  );
};

export default AgentNumberBadge;
